import { theme } from "@dashboard/assets/theme";

interface LogoProps {
  svgClass?: string;
  svgColor?: string;
  svgWidth?: number;
  svgHeight?: number;
}

export const Logo = ({
  svgColor,
  svgWidth,
  svgHeight,
  svgClass,
}: LogoProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={svgWidth ?? 146}
      height={svgHeight ?? 54}
      viewBox="0 0 146 54"
      fill="none"
      aria-labelledby="alt"
      className={svgClass ?? ""}
    >
      <title id="alt">Domun logo</title>
      <path
        fill={svgColor ?? theme.colors.white}
        d="M69.659 21.668v-7.973h3.008V34.25h-2.955v-2.035q-1.898 2.386-4.906 2.387-3.172 0-5.231-2.195-2.088-2.25-2.087-5.478c0-2.151.697-3.942 2.087-5.424q2.06-2.224 5.203-2.224 2.901.001 4.878 2.387zm.216 5.261q0-2.062-1.301-3.47-1.303-1.437-3.388-1.438t-3.388 1.438q-1.303 1.41-1.302 3.47c0 1.374.433 2.585 1.302 3.526q1.3 1.41 3.388 1.41t3.388-1.41q1.302-1.41 1.301-3.526m4.69 0q0-3.172 2.167-5.425 2.195-2.25 5.556-2.251 3.36 0 5.53 2.251 2.194 2.223 2.195 5.425c0 2.135-.733 3.995-2.195 5.477q-2.144 2.224-5.53 2.224c-2.26 0-4.093-.741-5.556-2.224q-2.167-2.249-2.167-5.477m12.443 0q0-2.006-1.382-3.445-1.329-1.464-3.333-1.463c-1.335 0-2.439.488-3.36 1.463q-1.356 1.437-1.354 3.445c0 1.338.452 2.512 1.354 3.47q1.382 1.437 3.36 1.438 1.978.002 3.333-1.438 1.382-1.437 1.382-3.47m22.035-7.701q2.629 0 4.229 1.708 1.627 1.652 1.627 4.583v8.731h-2.981v-8.242q0-1.898-.893-2.943-.895-1.045-2.439-1.044-1.627.002-2.642 1.11-1.016 1.113-1.016 2.957v8.162h-2.98v-8.19q0-1.87-.907-2.956-.909-1.084-2.453-1.086-1.627 0-2.656 1.125-1.031 1.125-1.03 2.995v8.11h-2.98V19.63h2.928v2.115a4.8 4.8 0 0 1 1.815-1.843q1.163-.678 2.602-.677c.994.019 1.898.26 2.711.733a4.25 4.25 0 0 1 1.79 1.951q.757-1.22 2.181-1.951a6.7 6.7 0 0 1 3.103-.733zm14.635 15.375q-2.925 0-4.662-1.707-1.735-1.709-1.734-4.637v-8.622h2.98v8.595q0 1.654.908 2.629.907.976 2.508.977c1.069 0 1.926-.317 2.52-.95q.895-.95.894-2.656v-8.595h3.008v8.622q0 2.982-1.707 4.664-1.708 1.683-4.717 1.683zm11.98-.353h-2.981V19.633h2.928v2.06q.65-1.137 1.87-1.79 1.22-.65 2.764-.65 2.414 0 4.065 1.574 1.682 1.6 1.682 4.528v8.895h-3.008v-8.054q0-1.979-.949-3.079-.95-1.1-2.547-1.099-1.682 0-2.75 1.18-1.071 1.18-1.072 3.05v7.999z"
      />
      <path
        fill={svgColor ?? theme.colors.accentGreenScale.g8}
        d="M50.498 21.796 31.673 2.96a7.523 7.523 0 0 0-10.642 0L2.203 21.796a7.53 7.53 0 0 0 0 10.647l18.825 18.833a7.52 7.52 0 0 0 10.642 0l18.825-18.833a7.53 7.53 0 0 0 0-10.647zm-21.336 18.33a7.808 7.808 0 0 1-13.442-5.405 7.805 7.805 0 0 1 13.572-5.26l1.876 1.804c1.03.839 3.1 2.102 5.897 1.039l-7.903 7.82zm2.72-10.154a208 208 0 0 1-9.558-9.609c-2.492-3.267-.546-8.761 3.597-9.405 2.264-.355 3.86.236 5.538 1.68a549 549 0 0 0 8.5 8.52c5.14 6.093-2.622 13.311-8.078 8.814"
      />
    </svg>
  );
};
